import { autoinject, newInstance } from 'aurelia-dependency-injection';
import { Router } from 'aurelia-router';
import { ValidationControllerFactory, ValidationRules, ValidationController } from 'aurelia-validation';
import { BootstrapFormRenderer } from '../../services/bootstrap-form-renderer';
import { CustomerInfoStore } from '../../services/customer-info-store';

@autoinject
export class ActivateToken {

    private controller: ValidationController

    constructor(@newInstance() factory: ValidationControllerFactory, private router: Router, private customerInfoStore: CustomerInfoStore) {
        this.controller = factory.createForCurrentScope();
    }

    organizationName: string = "";
    organizationId: string = "";
    token: string = null;
    isProduction: boolean;
    environmentType: string;
    isRequesting = false;
    renderer: BootstrapFormRenderer = null;

    activate(model: { organizationId: string, organizationName: string }) {
        console.log("ActivateToken.activate", model);
        this.organizationId = model.organizationId;
        this.organizationName = model.organizationName;
    }

    bind() {
        console.log('ActivateToken.bind');
        this.renderer = new BootstrapFormRenderer();
        this.controller.addRenderer(this.renderer);
    }
    unbind() {
        this.controller.removeRenderer(this.renderer);
    }

    async activateToken() {
        console.log('ActivateToken.activateToken')
        if (this.isRequesting) {
            return;
        }
        this.isRequesting = true;

        // Set isProduction
        this.isProduction = this.environmentType === "production";

        const validationResult = await this.controller.validate();

        if (!validationResult.valid) {
            console.log(`form not valid`, validationResult.results);
            this.isRequesting = false;
            return;
        }
        try {
            await this.customerInfoStore.activateByToken(this);
        } catch (e) {
            let errorMessage: string = e instanceof Error
                ? e.message
                : String(e);

            this.router.navigateToRoute('error', { errorMessage });
        }
        finally {
            this.isRequesting = false;
        }
    }
}

ValidationRules
    .ensure((p: ActivateToken) => p.token).required()
    .ensure((p: ActivateToken) => p.environmentType).required()
    .on(ActivateToken);


// WEBPACK FOOTER //
// ./ClientApp/app/components/register-organization/activate-token.ts